import { render, staticRenderFns } from "./auditpoint.vue?vue&type=template&id=fad7692c"
import script from "./auditpoint.vue?vue&type=script&lang=js"
export * from "./auditpoint.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports